import { useScrollFadeIn } from "../../hooks/useScrollFadeIn";

export const AnimatedWrapper = ({ children, style }: any) => {
  const animationProps = useScrollFadeIn();
  return (
    <div ref={animationProps.ref} style={{ ...animationProps.style, ...style }}>
      {children}
    </div>
  );
};